import React, { useMemo } from 'react';

import { get } from '@atlas/core';

import FormMobile from 'common/Form/FormMobile';
import CaptchaContext from 'common/Form/FormWithCaptcha/CaptchaContext';
import useFormCaptchaState from 'common/Form/FormWithCaptcha/useFormCaptchaState';

const FormWithCaptcha = ({ additionalValues, formType, onError, ...props }) => {
  const initialCaptchaKey = get(formType, 'optionalParams.captchaKey');
  const initialCaptchaRequired = get(formType, 'optionalParams.captchaRequired');

  const captchaData = useFormCaptchaState(initialCaptchaKey, initialCaptchaRequired, onError);
  const { handleError, input: captchaInput } = captchaData;

  const mergedAdditionalValues = useMemo(
    () => Object.assign(additionalValues ?? {}, { CAPTCHA_INPUT: captchaInput }),
    [additionalValues, captchaInput],
  );

  return (
    <CaptchaContext.Provider value={captchaData}>
      <FormMobile
        {...props}
        additionalValues={mergedAdditionalValues}
        formType={formType}
        onError={handleError}
      />
    </CaptchaContext.Provider>
  );
};

export default FormWithCaptcha;
